import React, { useContext, useEffect, useState } from "react";
import axios from "../../../axios/index";

// Context
import { UserContext } from "../../Context/UserContextProvider";

import Dropdown from "react-bootstrap/Dropdown";
import LimitationModalAllConsultants from "./LimitationModalAllConsultants/LimitationModalAllConsultants";

// Styles
import styles from "./DashboardFileManagement.module.css";
import customStyle from "./FileManagementCustom.module.css";
import style from "./ArchiveManagmenet.module.css";

//Images
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowDown from "../../../assets/img/DashboardICons/ArrowDown.svg";
import filterIcon from "../../../assets/img/DashboardICons/FilterIcon.svg";
import orderIcon from "../../../assets/img/DashboardICons/OrderIcon.svg";
import CategorySelector from "./CategorySelector/CategorySelector";
import { DealTypeBtn } from "./FileManagementCustomBtns/DealTypeBtn";
import { UsageTypeBtn } from "./FileManagementCustomBtns/UsageTypeBts";
import { MelkTypeBtn } from "./FileManagementCustomBtns/MelkTypeBtn";
import { RegionBtn } from "./FileManagementCustomBtns/RegionBtn";
import { OrderBtn } from "./FileManagementCustomBtns/OrderBtn";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Grid2X2Icon, TableOfContentsIcon } from "lucide-react";

const FileManagementBtns = props => {
  console.log("table type", props.tableType);
  const history = useHistory();
  const { userToken, permissions, userData } = useContext(UserContext);
  const [limitationModal, setLimitationModal] = useState(false);

  useEffect(() => {
    if (props.tableType !== localStorage.getItem("tableType")) props.setTableType(localStorage.getItem("tableType") || "card");
  }, [props.tableType, props.subCategory]);

  function generateCategoriesString() {
    let queryString = "";

    if (props.dealType != -1) {
      queryString += "&DealType=" + props.dealType;

      if (props.mainCategory != 0) {
        queryString += "&MainCategory=" + props.mainCategory;

        if (props.subCategory != 0) {
          queryString += "&SubCategory=" + props.subCategory;

          props.categories.forEach(region => {
            queryString += "&RegionCategories=" + region;
          });
        }
      }
    }
    return queryString;
  }

  function redirectBack() {
    history.goBack();
  }

  let [isDel, setIsDel] = useState(false);

  let dealType = props.dealType;
  let mainCategories = props.categoriesData.filter(c => c.parentId == null && c.dealType == props.dealType);

  let subCategories = props.categoriesData.filter(c => c.parentId == props.mainCategory);
  let regionCategories = props.categoriesData.filter(c => c.parentId == props.subCategory);

  return (
    <>
      <LimitationModalAllConsultants show={limitationModal} onHide={() => setLimitationModal(false)} />

      <style type="text/css">
        {`
                    .dropdown-toggle {
                        width: 159px;
                        height: 44px;
                        background: #f9f9f9;
                        border: 1px solid #e2e2e2;
                        border-radius: 34px;
                        margin-left: 0.75rem;
                        color: #1D1D1D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-success:after {
                        content: none;
                    }
                    
                    .btn-success {
                        background: #f9f9f9 !important;
                        border: 1px solid #e2e2e2 !important;
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }
                
                    .dropdown-menu {
                        height: 165px !important;
                        overflow-y: scroll;
                        background: #F9F9F9;
                        border: 1px solid #E1E1E1;
                        border-radius: 34px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                   .dropdown-menu::-webkit-scrollbar{
                    width: 3px;
                    height: 50px;
                    }
                    
                    .dropdown-menu::-webkit-scrollbar-track {
                        background: transparent;
                        margin-block: 10px;
                    }
                
                    .dropdown-menu::-webkit-scrollbar-thumb {
                        background: #B4B4B4;
                        border-radius: 20px;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
    `}
      </style>

      <div className={`py-2 ${props.class}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
            <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
              <a href="#" onClick={history.goBack}>
                <img className="ms-2" src={arrowIcon} alt="icon" />
              </a>
              <div className={styles.text1}>{props.title}</div>
            </div>

            <div
              className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-4 mb-2"
              style={{
                gap: "15px",
              }}>
              <div className={`${customStyle.buttonsHolder}`}>
                <DealTypeBtn
                  setFunction={value => {
                    props.updateFunction(value, 0);
                  }}
                  dealType={dealType}></DealTypeBtn>
                <UsageTypeBtn setFunction={value => props.updateFunction(value, 1)} categories={mainCategories} selected={props.mainCategory}></UsageTypeBtn>
                <MelkTypeBtn setFunction={value => props.updateFunction(value, 2)} categories={subCategories} selected={props.subCategory}></MelkTypeBtn>
                <RegionBtn setFunction={value => props.updateFunction(value, 3)} categories={regionCategories} selected={props.categories}></RegionBtn>
              </div>

              {
                <div
                  className={`d-flex align-items-center justify-content-between ${styles.filter_btns_left_container}`}
                  style={{
                    gap: "5px",
                  }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                    }}>
                    {permissions?.find(item => item === 15) === 15 ? (
                      <div className={`d-flex align-items-center justify-content-around ${styles.filter_btn_container}`}>
                        <button className={`d-flex align-items-center justify-content-center ${styles.filter_btn}`} onClick={() => setLimitationModal(true)}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ width: "30px", height: "30px" }}>
                            <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
                          </svg>
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className={`d-flex align-items-center justify-content-around ${styles.filter_btn_container}`}>
                      <button
                        className={`d-flex align-items-center justify-content-center ${styles.filter_btn}`}
                        onClick={() =>
                          props.setFilterParams(prev => {
                            return { ...prev, showModal: true };
                          })
                        }>
                        <img style={{ width: "30px", height: "30px" }} src={filterIcon} alt="icon" />
                      </button>
                    </div>
                    {props.isArchive ? (
                      <div className={`d-flex align-items-center justify-content-around ms-3 ${styles.filter_btn_container}`}>
                        <div className={`d-flex align-items-center ${styles.filter_btn} ${style.is_del}`}>
                          <div
                            className={`${style.is_del_text} ${!isDel ? style.is_del_text_active : ""}`}
                            onClick={() => {
                              setIsDel(false);
                              props.setIsDel(false);
                            }}>
                            بایگانی
                          </div>
                          <div
                            className={`${style.is_del_text} ${isDel ? style.is_del_text_active : ""}`}
                            onClick={() => {
                              setIsDel(true);
                              props.setIsDel(true);
                            }}>
                            حذف
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}

                    <OrderBtn setFunction={orderHandler}></OrderBtn>
                  </div>

                  <div
                    style={{
                      height: "40px",
                      width: "1.5px",
                      backgroundColor: "#cccccc",
                    }}></div>

                  {props.tableType ? (
                    <>
                      {props.selectedSubCategory ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            style={{
                              // borderRight: "2px solid rgb(72, 72, 72)",
                              padding: "5px 10px",
                              opacity: props.tableType === "card" ? 1 : 0.5,
                              outline: "none",
                            }}
                            onClick={() => {
                              props.setTableType("card");
                              localStorage.setItem("tableType", "card");
                            }}>
                            <Grid2X2Icon size={27} />
                          </button>
                          <button
                            style={{
                              borderRight: "1px solid #cccccc",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              opacity: props.tableType === "table" ? 1 : 0.5,
                              outline: "none",
                            }}
                            onClick={() => {
                              props.setTableType("table");
                              localStorage.setItem("tableType", "table");
                            }}>
                            <TableOfContentsIcon size={30} />
                          </button>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );

  async function orderHandler(event) {
    const id = event.target.id;
    if (props.placesFiles) {
      if (id === "popular") {
        props.setIsLoading(prev => {
          return { ...prev, isLoading: true };
        });
        const getSalesData = await axios.get(
          `Consultant/ConsultantAreaFile?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=1${generateCategoriesString()}`,
          {
            headers: { authorization: "Bearer " + userToken },
          }
        );
        const salesData = getSalesData.data.data.data;
        props.setCardData(salesData);
        props.setIsLoading(false);
      } else if (id === "news") {
        props.setIsLoading(prev => {
          return { ...prev, isLoading: true };
        });
        const getSalesData = await axios.get(
          `Consultant/ConsultantAreaFile?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=2${generateCategoriesString()}`,
          {
            headers: { authorization: "Bearer " + userToken },
          }
        );
        const salesData = getSalesData.data.data.data;
        props.setCardData(salesData);
        props.setIsLoading(false);
      } else if (id === "olds") {
        props.setIsLoading(prev => {
          return { ...prev, isLoading: true };
        });
        const getSalesData = await axios.get(
          `Consultant/ConsultantAreaFile?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=3${generateCategoriesString()}`,
          {
            headers: { authorization: "Bearer " + userToken },
          }
        );
        const salesData = getSalesData.data.data.data;
        props.setCardData(salesData);
        props.setIsLoading(false);
      }
    } else {
      if (id === "popular") {
        props.setIsLoading(true);
        if (props.UserSaved) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate/UserSavedEstates?EstateType=${dealType == 1 ? "2" : "1"}&OrderBy=1${generateCategoriesString()}`
              : `Estate/UserSavedEstates?EstateType=${dealType == 1 ? "2" : "1"}&OrderBy=1&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData?.data.data.data || [];
          props.setCardData(salesData);
        } else if (props.userFiles) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=4&Take=6&OrderBy=1${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=4&Take=6&OrderBy=1&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        } else if (props.archiveFiles) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=5&Take=6&OrderBy=1${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=5&Take=6&OrderBy=1&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        } else {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=1${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=1&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        }
        props.setIsLoading(false);
      } else if (id === "news") {
        props.setIsLoading(true);
        if (props.UserSaved) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate/UserSavedEstates?EstateType=${dealType == 1 ? "2" : "1"}&OrderBy=2${generateCategoriesString()}`
              : `Estate/UserSavedEstates?EstateType=${dealType == 1 ? "2" : "1"}&OrderBy=2&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData?.data.data.data || [];
          props.setCardData(salesData);
        } else if (props.userFiles) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=4&Take=6&OrderBy=2${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=4&Take=6&OrderBy=2&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        } else if (props.archiveFiles) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=5&Take=6&OrderBy=2${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=5&Take=6&OrderBy=2&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        } else {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=2${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=2&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        }
        props.setIsLoading(false);
      } else if (id === "olds") {
        props.setIsLoading(true);
        if (props.UserSaved) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate/UserSavedEstates?EstateType=${dealType == 1 ? "2" : "1"}&OrderBy=3${generateCategoriesString()}`
              : `Estate/UserSavedEstates?EstateType=${dealType == 1 ? "2" : "1"}&OrderBy=3&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData?.data.data.data || [];
          props.setCardData(salesData);
        } else if (props.userFiles) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=4&Take=6&OrderBy=3${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=4&Take=6&OrderBy=3&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        } else if (props.archiveFiles) {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=5&Take=6&OrderBy=3${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=5&Take=6&OrderBy=3&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        } else {
          const getSalesData = await axios.get(
            permissions?.find(item => item === 15) === 15
              ? `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=3${generateCategoriesString()}`
              : `Estate?EstateType=${dealType == 1 ? "2" : "1"}&Status=2&Take=6&OrderBy=3&UserId=${userData.id}${generateCategoriesString()}`,
            {
              headers: { authorization: "Bearer " + userToken },
            }
          );
          const salesData = getSalesData.data.data.data;
          props.setCardData(salesData);
        }
        props.setIsLoading(false);
      }
    }
  }
};

export default FileManagementBtns;
